import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
export function Navigation() {
  const [isOpen, setIsOpen] = useState(false);
  const navLinks = [{
    name: 'Services',
    href: '#services'
  }, {
    name: 'About',
    href: '#trust'
  }, {
    name: 'Testimonials',
    href: '#testimonials'
  }, {
    name: 'Contact',
    href: '#contact'
  }];
  return <nav className="fixed top-0 left-0 right-0 bg-white/95 backdrop-blur-sm z-50 border-b border-gray-100 shadow-sm" data-id="element-93">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-94">
        <div className="flex justify-between items-center h-20" data-id="element-95">
          {/* Logo */}
          <div className="flex-shrink-0 flex items-center" data-id="element-96">
            <a href="#" className="text-2xl font-bold text-navy-900 tracking-tight" data-id="element-97">
              Tech Vero <span className="text-blue-600" data-id="element-98">Solutions</span>
            </a>
          </div>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center space-x-8" data-id="element-99">
            {navLinks.map(link => <a key={link.name} href={link.href} className="text-gray-600 hover:text-navy-900 font-medium transition-colors duration-200" data-id="element-100">
                {link.name}
              </a>)}
            <a href="#contact" className="bg-navy-900 text-white px-6 py-2.5 rounded-md font-medium hover:bg-navy-800 transition-colors duration-200 shadow-md hover:shadow-lg transform hover:-translate-y-0.5" data-id="element-101">
              Get Started
            </a>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden flex items-center" data-id="element-102">
            <button onClick={() => setIsOpen(!isOpen)} className="text-gray-600 hover:text-navy-900 focus:outline-none p-2" aria-label="Toggle menu" data-id="element-103">
              {isOpen ? <X className="h-6 w-6" data-id="element-104" /> : <Menu className="h-6 w-6" data-id="element-105" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Nav */}
      {isOpen && <div className="md:hidden bg-white border-t border-gray-100 absolute w-full shadow-lg" data-id="element-106">
          <div className="px-4 pt-2 pb-6 space-y-2" data-id="element-107">
            {navLinks.map(link => <a key={link.name} href={link.href} onClick={() => setIsOpen(false)} className="block px-3 py-3 text-base font-medium text-gray-600 hover:text-navy-900 hover:bg-gray-50 rounded-md" data-id="element-108">
                {link.name}
              </a>)}
            <div className="pt-4" data-id="element-109">
              <a href="#contact" onClick={() => setIsOpen(false)} className="block w-full text-center bg-navy-900 text-white px-6 py-3 rounded-md font-medium hover:bg-navy-800 transition-colors" data-id="element-110">
                Get Started
              </a>
            </div>
          </div>
        </div>}
    </nav>;
}